/**
 * @file 活动相关
 */
import { useUserStore } from '@/store/User';
import { pinia } from './index';
import { plus, gt, lt } from '@/utils/number';
import { activityApi, affiliates } from '@/config/api.ts';

const userStore = useUserStore(pinia);

export const useActivityStore = defineStore('activityStore', {
  state: () => ({
    startTime: <null | number>null,
    endTime: <null | number>null,
    timeDifference: <null | number>null,
    serverTime: <null | number>null,
    isFinished: <boolean>false,
    isVisible: <boolean>false,
    // 专属活动数据
    exclusiveActivityRes: <any>{}
  }),
  getters: {
    // 未登录 并且 一天内没有过弹窗
    homeDialog() {
      return !userStore.isLogin && localStorage.getItem('activityVisible') !== new Date().toDateString();
    }
  },
  actions: {
    async getActivityTime() {
      const res: any = await activityApi.experience_card_info({ activityName: 'futures-activity' });
      if (res.success) {
        this.startTime = res.data.startTime;
        this.endTime = res.data.endTime;
        this.endTime = res.data.endTime;
        this.serverTime = res.data.serverTime;
        this.timeDifference = res.data.serverTime - new Date().getTime();
        this.isFinished = res.data.isFinished;
        this.isVisible = res.data.isVisible;
      }
    },
    isActivityTime(time:number) {
      const nowTime = plus(time, this.timeDifference);
      return lt(this.startTime, nowTime) && gt(this.endTime, nowTime);
    },
    async getExclusiveActivity(invite_code: string, activityId: any = '') {
      const res: any = await affiliates.getExclusiveActivity({
        inviteCode: invite_code,
        activityType: 1,
        activityId: activityId || ''
      });

      if (res.success && res.code === 200) {
        this.exclusiveActivityRes = res;
      }

      return res;
    }
  }
});
